/**
 * Seed analyses for the Lockerroom library.
 *
 * DELIBERATELY EMPTY. The illustrative analyses were removed so the library
 * shows only what this installation has actually produced — a saved agent run
 * or an uploaded document. A bench pre-populated with invented client work is
 * indistinguishable, at a glance, from real work.
 *
 * The seed stays as an exported empty array rather than being deleted outright:
 * `SessionBootstrap` hydrates from it, and `deriveSeedKpis` recomputes any
 * Strategic Relevance KPIs from `src/domain/sr` at hydration. Both still work
 * over an empty list, and the shape is here for whoever repopulates it.
 */

import type { Analysis } from '../../contracts';

export const SEED_ANALYSES: readonly Analysis[] = [];
